import Dexie from "dexie";

import global from "../global.js";

// const log = global.log.getLogger("f_mtac.configuration.store");

const Store = function (name, data, private_interface) {
    var master = private_interface.master;
    var room = null;
    var created = new Date();
    var modified = new Date(created.getTime());
    var stored = new Date(0);
    this.init = (new_room) => {
        let old_room = room;
        if (String(old_room) === String(new_room)) {
            return;
        }
        room = new_room;
        stored.setTime(0);
    };
    this.deinit = () => {
        room = null;
        stored.setTime(0);
    };
    this.touch = function () {
        modified.setTime(Date.now());
    };
    this.save = async function () {
        if (stored.valueOf() === 0) {
            await master.stores.put({name, data});
        } else {
            if (modified < stored) {
                return;
            }
            await master.stores
                .where("name")
                .equals(name)
                .modify((store_data) => {
                Object.assign(store_data.data, data);
            });
        }
        stored.setTime(Date.now());
    };
    this.loaded = async function () {
        stored.setTime(Date.now());
    };
    this.load = async function () {
        let store_data = await master.stores.get(name);
        if (store_data !== undefined) {
            this.loaded();
            return;
        }
        await this.save();
    };
    this.delete = async function () {
        await master.stores.delete(name);
        private_interface.deindex(name);
    };
    this.apply = function (modifications) {
        for (let key in modifications) {
            if (!key.startsWith("data.")) {
                continue;
            }
            let path = key.substr("data.".length);
            Dexie.setByKeyPath(data, path, modifications[key]);
        }
    };
    this.on = function (event_name, handler) {
        switch (event_name) {
        case "update":
            global.event_bus.subscribe(`configuration.store.updated.${name}`, handler);
            break;
        case "create":
            global.event_bus.subscribe(`configuration.store.created.${name}`, handler);
            break;
        }
    };
    Object.defineProperty(this, "name", {
        set: () => {},
        get: () => name
    });
    Object.defineProperty(this, "data", {
        set: () => {},
        get: () => data
    });
    const export_handlers = {
        get: (target, property) => {
            if (!(property in target)) {
                return;
            }
            const value = target[property];
            if (typeof value === "object" && value !== null) {
                return new Proxy(value, export_handlers);
            }
            return value;
        },
        set: (target, property, value) => {
            target[property] = value;
            this.touch();
            return true;
        }
    };
    const export_handler = new Proxy(data, export_handlers);
    this.export = () => export_handler;
    private_interface.index(name, this);
};

export default Store;
